var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeader = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 160,
  height: 81,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 158,
  height: 79,
  x: 1,
  y: 1,
  fill: "var(--hop-neutral-surface)",
  rx: 7
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 158,
  height: 79,
  x: 1,
  y: 1,
  stroke: "var(--hop-neutral-border-weak)",
  strokeWidth: 2,
  rx: 7
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 150,
  height: 21,
  x: 5,
  y: 7,
  stroke: "var(--hop-neutral-border-strong)",
  strokeDasharray: "4 6",
  strokeLinecap: "round",
  strokeWidth: 2,
  rx: 2
})));
export default SvgHeader;